import { createAction } from 'redux-actions';

import * as C from './constants';

export const getSubmissionListRequest = createAction(C.GET_SUBMISSION_LIST_REQUEST);
export const getSubmissionListSuccess = createAction(C.GET_SUBMISSION_LIST_SUCCESS);
export const updateFilters = createAction(C.UPDATE_FILTERS);
export const updateSearch = createAction(C.UPDATE_SEARCH);
